import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { incrementTimer } from '../../recorderSlice';

const Timer = () => {
  const dispatch = useDispatch();
  const timer = useSelector((state: RootState) => state.recorder.timer);
  const status = useSelector((state: RootState) => state.recorder.status);

  useEffect(() => {
    let timerInterval: ReturnType<typeof setInterval>;
    if (status === 'recording') {
      timerInterval = setInterval(() => {
        dispatch(incrementTimer());
      }, 1000);
    }
    return () => {
      if (timerInterval) {
        clearInterval(timerInterval);
      }
    };
  }, [status, dispatch]);

  const formatTime = (time: number) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;

    if (hours > 0) {
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
        2,
        '0',
      )}:${String(seconds).padStart(2, '0')}`;
    }

    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
      2,
      '0',
    )}`;
  };

  return <span>{formatTime(timer)}</span>;
};

export default Timer;
